// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"410":"c095f131","886":"e0698e39"}[chunkId] + ".css";
};